import { render, staticRenderFns } from "./ComplianceCustom.vue?vue&type=template&id=63152451&"
import script from "./ComplianceCustom.vue?vue&type=script&lang=js&"
export * from "./ComplianceCustom.vue?vue&type=script&lang=js&"
import style0 from "./ComplianceCustom.vue?vue&type=style&index=0&id=63152451&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports